import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import MInstallmentIcon from 'shared/images/minstallment.svg'
import { priceShow } from 'shared/lib/priceShow'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface PropsMinstallment {
  tranche?: string
  month?: number
}

export const MinstallmentText = ({ tranche, month }: PropsMinstallment) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <ImageLazy
        src={MInstallmentIcon}
        className={s.icon}
      />
      <p className={clsx(s.mplusPrice, 'semi-bold-11')}>
        {t('minstallment.tag_info', {
          price: priceShow(tranche),
          month: month,
        })}
      </p>
    </div>
  )
}
